"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTuberculosisScreeningWorkHistoryQuestionCreateDto = instanceOfTuberculosisScreeningWorkHistoryQuestionCreateDto;
exports.TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSON = TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSON;
exports.TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSONTyped = TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSONTyped;
exports.TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSON = TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSON;
exports.TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSONTyped = TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSONTyped;
/**
 * Check if a given object implements the TuberculosisScreeningWorkHistoryQuestionCreateDto interface.
 */
function instanceOfTuberculosisScreeningWorkHistoryQuestionCreateDto(value) {
    if (!('code' in value) || value['code'] === undefined)
        return false;
    if (!('answer' in value) || value['answer'] === undefined)
        return false;
    return true;
}
function TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSON(json) {
    return TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSONTyped(json, false);
}
function TuberculosisScreeningWorkHistoryQuestionCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'code': json['code'],
        'answer': json['answer'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}
function TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSON(json) {
    return TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSONTyped(json, false);
}
function TuberculosisScreeningWorkHistoryQuestionCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'code': value['code'],
        'answer': value['answer'],
        'date': value['date'] == null ? undefined : (value['date'].toISOString().substring(0, 10)),
    };
}
//# sourceMappingURL=TuberculosisScreeningWorkHistoryQuestionCreateDto.js.map